import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import styles from './Divider.module.scss';

export type DividerProps = {
    type?: 'horizontal' | 'vertical';
    orientation?: 'left' | 'right' | 'center';
    orientationMargin?: number;
    children?: ReactNode;
    className?: string;
};

export const Divider = ({
    type = 'horizontal',
    orientation = 'center',
    orientationMargin,
    children,
    className
}: DividerProps): ReactElement => {
    if (!children) {
        return (
            <div
                className={classnames(styles.root, styles[type], styles.empty, className)}
                aria-hidden="true"
            />
        );
    }

    return (
        <div
            className={classnames(
                styles.root,
                styles[type],
                styles.withText,
                orientation && styles[orientation],
                className
            )}
        >
            <div
                className={styles.separator}
                style={
                    orientation === 'left' && orientationMargin
                        ? { flex: `0 0 ${orientationMargin}px` }
                        : undefined
                }
                aria-hidden="true"
            />
            <span className={styles.text}>{children}</span>
            <div
                className={styles.separator}
                style={
                    orientation === 'right' && orientationMargin
                        ? { flex: `0 0 ${orientationMargin}px` }
                        : undefined
                }
                aria-hidden="true"
            />
        </div>
    );
};
